import { ModalControlsSaveableFactory } from '®shared/modals';

import {
  RequestDigitisationActionTypes,
  RequestDigitisationActions,
} from './request-digitisation.actions';
import { RequestDigitisationState } from './request-digitisation.state';

export function requestDigitisationReducer(
  state: RequestDigitisationState,
  action: RequestDigitisationActions,
): RequestDigitisationState {
  switch (action.type) {
    case RequestDigitisationActionTypes.OPEN_REQUEST_DIGITISATION_URL: {
      const { requestDigitisationUrl, item } = action.payload;
      return {
        ...state,
        requestDigitisationUrl,
        currentItem: item,
        modalControls: ModalControlsSaveableFactory.show(),
      };
    }
    case RequestDigitisationActionTypes.OPEN_REQUEST_DIGITISATION_IDENTIFIER_PICKER: {
      const { item, user } = action.payload;
      return {
        ...state,
        requestDigitisationUrl: null,
        currentItem: item,
        selectedIdentifier: null,
        modalControls: ModalControlsSaveableFactory.show(),
        user,
      };
    }
    case RequestDigitisationActionTypes.SELECT_REQUEST_DIGITISATION_IDENTIFIER: {
      const { selectedIdentifier, item } = action.payload;
      return {
        ...state,
        requestDigitisationUrl: null,
        currentItem: item,
        selectedIdentifier: selectedIdentifier,
        modalControls: ModalControlsSaveableFactory.show(),
      };
    }
    case RequestDigitisationActionTypes.HIDE_REQUEST_DIGITISATION_MODAL: {
      return {
        ...state,
        requestDigitisationUrl: null,
        currentItem: null,
        selectedIdentifier: null,
        modalControls: ModalControlsSaveableFactory.hide(),
      };
    }
    default: {
      return state;
    }
  }
}
